import { LettersTable } from 'components/features'

import { Container, Title, ContentWrap } from './Style'

export function Letters() {
  return (
    <Container>
      <Title>Letters</Title>
      <ContentWrap>
        <LettersTable />
      </ContentWrap>
    </Container>
  )
}
